export default __webpack_public_path__ + "static/media/request_prize-stap_02.cdd683a5.png";